import { formDataType, FormFieldType } from "./OfficeProfileData";

export const formDataInitialState: formDataType[] = [
  {
    id: "companyName",
    value: "",
    title: "Company Name",
    placeholder: "Please provide company name",
    required: true,
    errorMessage: "Please provide company name",
    valid: false,
    type: FormFieldType.TextInput,
  },
  {
    id: "officeAddress",
    value: "",
    title: "Office Address",
    placeholder: "Please provide address",
    required: true,
    errorMessage: "Please provide valid office address",
    valid: false,
    type: FormFieldType.Places,
  },

  {
    id: "bankName",
    value: "",
    title: "Name of Bank",
    placeholder: "Enter bank name",
    required: false,
    errorMessage: "Please provide bank name",
    valid: true,
    type: FormFieldType.TextInput,
  },
  {
    id: "bankCode",
    value: "",
    title: "Bank Code",
    placeholder: "Please provide bank code",
    required: true,
    errorMessage: "Bank code must be exactly 3 digits",
    valid: false,
    type: FormFieldType.Number,
  },
  {
    id: "transitNumber",
    value: "",
    title: "Transit Number",
    placeholder: "Please provide transit number",
    required: true,
    errorMessage: "Transit number must be maximum 5 digits",
    valid: false,
    type: FormFieldType.Number,
  },
  {
    id: "accountNumber",
    value: "",
    title: "Account Number",
    placeholder: "Please provide account number",
    required: true,
    errorMessage: "Account number must be maximum 7 digits",
    valid: false,
    type: FormFieldType.Number,
  },
];
